import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#c20a0a', // #E53935
                secondary: '#c20a0a', // #FFCDD2
                accent: '#c20a0a', // #3F51B5
            },
        },
        dark: false
    },
})
